import Tables from 'src/class/Tables';
import Formatter from 'src/class/Formatter';
import UnitPriceErrorFormatter from './UnitPriceErrorFormatter';
import SubTotalErrorFormatter from './SubTotalErrorFormatter';
import IncrementRateFormatter from './IncrementRateFormatter';
import moment from 'moment';
import i18n from 'src/i18n';

const configTable = () => {
  const Table = { ...Tables.Table };

  Table.tableColumns = [
    {
      prop: 'date_save',
      label: i18n.t('common_words.date'),
      minWidth: 180,
      sortable: true,
    },
    {
      prop: 'worker.code',
      label: i18n.t('common_words.code'),
      sortable: true,
      minWidth: 100,
      align: 'center',
    },
    {
      prop: 'worker.first_name',
      label: i18n.t('labor.worker'),
      minWidth: 180,
      sortable: true,
      formatter: (row) => `${row.worker.first_name} ${row.worker.last_name}`,
    },
    {
      prop: 'farm.name',
      label: i18n.t('common_words.farm'),
      minWidth: 150,
      sortable: true,
    },
    {
      prop: 'signature',
      label: i18n.t('common_words.status'),
      minWidth: 180,
      sortable: true,
      align: 'center',
      formatter: (row) => `${row.signature ? 'Firmado' : 'No Firmado'}`,
    },
    {
      prop: 'user_name',
      label: i18n.t('common_words.typing_user'),
      minWidth: 180,
      sortable: true,
    },
    {
      prop: 'observations',
      label: i18n.t('common_words.observation'),
      minWidth: 250,
      sortable: true,
    },
  ];

  const TableDetails = { ...Tables.Table };

  TableDetails.tableColumns = [
    {
      prop: 'full_date',
      label: i18n.t('common_words.date'),
      minWidth: 100,
      sortable: true,
      formatter: (row) => {
        return moment(row.full_date).format('YYYY-MM-DD');
      },
    },
    {
      prop: 'activity.code',
      label: i18n.t('common_words.code'),
      minWidth: 80,
      sortable: true,
    },
    {
      prop: 'activity.name',
      label: i18n.t('common_words.activity'),
      minWidth: 200,
      sortable: true,
    },
    {
      prop: 'quantity',
      label: i18n.t('common_words.quantity'),
      minWidth: 100,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'activity.activity_unit_payment.abbreviation',
      label: i18n.t('labor.unit'),
    },
    {
      prop: 'number_hours',
      label: i18n.t('labor.hours_worked'),
      minWidth: 150,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'increment_rates',
      label: i18n.t('common_words.increments'),
      minWidth: 250,
      formatter: IncrementRateFormatter,
    },
    {
      prop: 'activity',
      label: i18n.t('labor.unit_value'),
      minWidth: 150,
      sortable: true,
      align: 'center',
      formatter: UnitPriceErrorFormatter,
    },
    {
      prop: 'subtotal',
      label: i18n.t('common_words.sub_total'),
      minWidth: 150,
      sortable: true,
      align: 'center',
      formatter: SubTotalErrorFormatter,
    },
    {
      prop: 'lot.name',
      label: i18n.t('common_words.allotment'),
      minWidth: 120,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'time_type',
      label: i18n.t('labor.hour_type'),
      minWidth: 200,
      sortable: true,
      formatter: (row, column) => {
        const { price_format, name, price } = row[column.property];

        /**
         * este campo de "temporalPrice" es para subsanar el requisito que todavía no se puede
         * implementar, acerca del historial de valores de tipos de hora, esto
         * tiene que irse después de que esté implementada la nueva solución.
         */
        const hasTemporalPrice =
          row['value_time_type'] &&
          row['value_time_type'].additional_percentage;
        const temporalPrice = hasTemporalPrice
          ? row['value_time_type'].additional_percentage
          : 'No hay valor adicional parametrizado, revisar los valores de actividad';

        const pre = price_format === '$' ? price_format : '';
        const post = price_format === '%' ? price_format : '';
        let text = `${name} ${pre}${Formatter.formatNumber(
          Number(temporalPrice)
        )}${post} adicional`;

        if (!hasTemporalPrice) {
          return temporalPrice;
        }

        return text;
      },
    },
    {
      prop: 'observations',
      label: i18n.t('common_words.observations'),
      minWidth: 200,
      sortable: true,
    },
  ];

  const SearchDetails = {
    pagedDataDetails() {
      return this.tableDataDetails.slice(this.fromDetails, this.toDetails);
    },

    /***
     * Searches through table data and returns a paginated array.
     * Note that this should not be used for table with a lot of data as it might be slow!
     * Do the search and the pagination on the server and display the data retrieved from server instead.
     * @returns {computed.pagedData}
     */
    queriedDataDetails() {
      let result = this.tableDataDetails;
      if (this.searchQueryDetails !== '') {
        result = this.fuseSearchDetails.search(
          '=' + this.searchQueryDetails + ''
        );
      }
      this.paginationDetails.total = result.length;

      if (this.$refs.cardfooterdetail) {
        this.$refs.cardfooterdetail.totals = this.paginationDetails.total;
      }

      return result.slice(this.fromDetails, this.toDetails);
    },

    toDetails() {
      let highBound = this.fromDetails + this.paginationDetails.perPage;
      if (this.totalDetails < highBound) {
        highBound = this.totalDetails;
      }

      if (this.$refs.cardfooterdetail) {
        this.$refs.cardfooterdetail.tos = highBound;
      }

      return highBound;
    },

    fromDetails() {
      let from =
        this.paginationDetails.perPage *
        (this.paginationDetails.currentPage - 1);
      if (this.$refs.cardfooterdetail) {
        this.$refs.cardfooterdetail.froms = from;
      }

      return from;
    },

    totalDetails() {
      if (this.$refs.cardfooterdetail) {
        this.$refs.cardfooterdetail.totals = this.paginationDetails.total;
      }

      return this.paginationDetails.total;
    },
  };

  return { Table, TableDetails, SearchDetails };
};

export default configTable;
